import Container from "./Container";

function App() {
  return (
    <div className="app">
      <Container />
    </div>
  );
}

export default App;
